import React from "react";
import { Action, ActionType } from "../@types";

export const setMbpReferrerUri = (
  dispatch: React.Dispatch<Action>,
  uri?: string
): void => {
  dispatch({
    type: ActionType.UPDATE_MBP_REFERRER_URI,
    payload: uri,
  });
};

const _clearMbpReferrerUri = (dispatch: React.Dispatch<Action>): void =>
  setMbpReferrerUri(dispatch, "");

export const clearMbpReferrerUri = (
  dispatch: React.Dispatch<Action>
): (() => void) => {
  return () => _clearMbpReferrerUri(dispatch);
};

export const mbpReferrerUriClickHandler = ({
  dispatch,
  mbpReferrerUri,
  e,
}: {
  dispatch: React.Dispatch<Action>;
  mbpReferrerUri: string;
  e: React.MouseEvent<HTMLAnchorElement, MouseEvent>;
}): void => {
  e.preventDefault();
  _clearMbpReferrerUri(dispatch);
  window?.location?.assign(mbpReferrerUri);
};
